import { AddOnTypes } from '../../utils/constants';

// Maps a billingStore/connectStore plan entry to the plan shape the shared
// Billing pricing components expect. CheckoutDrawer only reads name / code /
// chargifyCode / price.{monthly,currency}; the extra fields (id, description,
// features, addOns, isMostPopular) drive the plan card display.

// The billing store can return add-on types as raw Chargify component kinds
// (e.g. "quantity_based_component", "optin_based_component") instead of the
// canonical AddOnTypes the pricing helpers in conf/chargify.js check for —
// normalize once here, mirroring PlanCard's own isQuantityControl() check.
function normalizeAddOnType (addOn) {
    const type = addOn.type || '';
    const handle = addOn.handle || '';
    const isQuantityType = type === AddOnTypes.QUANTITY || type === 'quantity_based_component';
    const isToggleHandle = handle.indexOf('binary') !== -1 || handle.indexOf('toggle') !== -1;
    return (isQuantityType && !isToggleHandle) ? AddOnTypes.QUANTITY : AddOnTypes.ON_OFF;
}

export default function mapPlanToCard (plan, currency, isMostPopular = false) {
    return {
        id: plan.id,
        name: plan.name,
        code: plan.code || plan.handle,
        chargifyCode: plan.handle || plan.code,
        description: plan.description,
        features: plan.bullets || [],
        price: {
            monthly: Number(plan.price),
            currency,
        },
        addOns: (plan.addOns || []).map((addOn) => ({ ...addOn, type: normalizeAddOnType(addOn) })),
        isMostPopular,
    };
}
